export default __webpack_public_path__ + "static/media/random_pp.801be596.png";